import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SocialAuth = ({ onSocialLogin, loading = false }) => {
  const socialProviders = [
    {
      id: 'google',
      name: 'Google',
      icon: 'Chrome',
      color: 'text-red-500'
    },
    {
      id: 'linkedin_oidc',
      name: 'LinkedIn',
      icon: 'Linkedin',
      color: 'text-blue-600'
    },
    {
      id: 'azure',
      name: 'Microsoft',
      icon: 'Mail',
      color: 'text-blue-500'
    }
  ];

  const handleSocialLogin = async (provider) => {
    if (onSocialLogin) {
      await onSocialLogin(provider);
    }
  };

  return (
    <div className="space-y-3">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-2 bg-card text-muted-foreground">Or continue with</span>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {socialProviders?.map((provider) => (
          <Button
            key={provider?.id}
            variant="outline"
            size="default"
            onClick={() => handleSocialLogin(provider?.id)}
            disabled={loading}
            className="flex items-center justify-center space-x-2"
          >
            <Icon 
              name={provider?.icon} 
              size={18} 
              className={provider?.color}
            />
            <span>{provider?.name}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SocialAuth;